import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@env/environment';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';
import {UploadService} from '@common-components/file-upload/upload.service';
// import {map} from 'rxjs';
// import 'rxjs/Rx';
// import {map} from 'rxjs/operators';
// import {Pipe, PipeTransform} from '@angular/core';
// import 'rxjs/Rx';

@Injectable({
    providedIn: 'root'
})
export class FileDownloadService {
    private apiURL = environment.apiURL;

    constructor(public http: HttpClient, public uploadService: UploadService) {
    }

    public handleError(error: any): Promise<any> {

        return Promise.reject(error.message || error);
    }


    b64toBlob(b64Data, contentType = '', sliceSize = 512) {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }

    urlToBase64(item) {
        const ext = item.extension;
        const b64Data = item.base64;
        const blob = this.b64toBlob(b64Data);
        const blobUrl = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = blobUrl;
        anchor.download = item.data.real_name;
        anchor.click();

    }


    postFile(fileToUpload: File) {
        const headers = new HttpHeaders();
        const endpoint = 'your-destination-url';
        const formData: FormData = new FormData();
        formData.append('fileKey', fileToUpload, fileToUpload.name);
        return this.http
            .post(endpoint, formData, {headers: headers})
    }


    public downloadFile(item) {
        let params = new HttpParams()
            .set('attachment', item);
        return this.http.post<any>(this.apiURL + '/upload/downloadFile', {params: params});
    }


}
